import { localizedTransactionStatus } from "../../intl/shared-resources/transactionStatus.js";
import { ChipVariant } from "../../components/chip/types.js";
import "../../components/icons/Icon.js";
import "react";
import { CustomIcon } from "../../components/icons/types.js";
import "../../components/icons/ExpandMoreIcon.js";
import { TransactionStatus } from "../../contract/pam.js";
const getTransactionStatusChipsMapping = (chipType) => ({
  [TransactionStatus.Cancelled]: {
    label: localizedTransactionStatus[TransactionStatus.Cancelled],
    chipType,
    chipVariant: ChipVariant.Yellow
  },
  [TransactionStatus.Pending]: {
    label: localizedTransactionStatus[TransactionStatus.Pending],
    chipType,
    chipVariant: ChipVariant.Disabled,
    startIconClass: CustomIcon.ClockOutline
  },
  [TransactionStatus.OnHoldRisk]: {
    label: localizedTransactionStatus[TransactionStatus.OnHoldRisk],
    chipType,
    chipVariant: ChipVariant.Orange,
    startIconClass: CustomIcon.WarningOutline
  },
  [TransactionStatus.OnHoldPayment]: {
    label: localizedTransactionStatus[TransactionStatus.OnHoldPayment],
    chipType,
    chipVariant: ChipVariant.Orange,
    startIconClass: CustomIcon.WarningOutline
  },
  [TransactionStatus.Failed]: {
    label: localizedTransactionStatus[TransactionStatus.Failed],
    chipType,
    chipVariant: ChipVariant.Yellow
  },
  [TransactionStatus.InProgress]: {
    label: localizedTransactionStatus[TransactionStatus.InProgress],
    chipType,
    chipVariant: ChipVariant.LightBlue,
    startIconClass: CustomIcon.Union
  },
  [TransactionStatus.Rejected]: {
    label: localizedTransactionStatus[TransactionStatus.Rejected],
    chipType,
    chipVariant: ChipVariant.Yellow
  },
  [TransactionStatus.Succeeded]: {
    label: localizedTransactionStatus[TransactionStatus.Succeeded],
    chipType,
    chipVariant: ChipVariant.Green,
    startIconClass: CustomIcon.Confirm
  },
  [TransactionStatus.RiskAuthorized]: {
    label: localizedTransactionStatus[TransactionStatus.RiskAuthorized],
    chipType,
    chipVariant: ChipVariant.Disabled,
    startIconClass: CustomIcon.ClockOutline
  }
});
export {
  getTransactionStatusChipsMapping
};
//# sourceMappingURL=transactionStatusChipConfig.js.map
